import {
    ContextMenu,
    AutoColumnSize,
    ManualColumnResize,
    ManualColumnMove,
    ManualRowMove,
    Formulas,
    CustomBorders,
    UndoRedo,
    Autofill,
    CopyPaste,
    MultipleSelectionHandles,
    registerPlugin,
} from 'handsontable/plugins';
import { registerEditor } from 'handsontable/editors';

// Milanote plugins
import DraftCellEditor from './modules/DraftCellEditor';
import FormulaCellReferenceHotPlugin from './plugins/FormulaCellReferenceHotPlugin';
import FormulaAutocompleteHotPlugin from './plugins/FormulaAutocompleteHotPlugin';
import DraftJSFormulaCellReferenceHotPlugin from './plugins/FormulaCellReferenceHotPlugin/DraftJSFormulaCellReferenceHotPlugin';
import DraftJSFormulaAutocompleteHotPlugin from './plugins/DraftJSFormulaAutocompleteHotPlugin';

import EditingHotPlugin from './plugins/EditingHotPlugin';
import EditingCleanupHotPlugin from './plugins/EditingCleanupHotPlugin';
import ContextMenuExtensionHotPlugin from './plugins/ContextMenuExtensionHotPlugin';
import ContextMenuShortcutsHotPlugin from './plugins/ContextMenuShortcutsHotPlugin';
import EditorShortcutsHotPlugin from './plugins/EditorShortcutsHotPlugin';
import GridShortcutsHotPlugin from './plugins/GridShortcutsHotPlugin';
import CopyPasteExtensionHotPlugin from './plugins/CopyPasteExtensionHotPlugin';
import FormulaTypeInferenceHotPlugin from './plugins/FormulaTypeInferenceHotPlugin';
import GridUpdateHotPlugin from './plugins/GridUpdateHotPlugin';

export const registerHotPlugins = () => {
    // Register Handonstable plugins
    registerPlugin(ContextMenu);
    registerPlugin(AutoColumnSize);
    registerPlugin(ManualColumnResize);
    registerPlugin(ManualColumnMove);
    registerPlugin(ManualRowMove);
    registerPlugin(Formulas);
    registerPlugin(CustomBorders);
    registerPlugin(UndoRedo);
    registerPlugin(Autofill);
    registerPlugin(CopyPaste);
    registerPlugin(MultipleSelectionHandles);

    // Register Handsontable custom plugins
    registerPlugin(FormulaCellReferenceHotPlugin);
    registerPlugin(FormulaAutocompleteHotPlugin);
    registerPlugin(EditingHotPlugin);
    registerPlugin(EditingCleanupHotPlugin);
    registerPlugin(ContextMenuExtensionHotPlugin);
    registerPlugin(GridShortcutsHotPlugin);
    registerPlugin(EditorShortcutsHotPlugin);
    registerPlugin(ContextMenuShortcutsHotPlugin);
    registerPlugin(CopyPasteExtensionHotPlugin);
    registerPlugin(GridUpdateHotPlugin);
    registerPlugin(FormulaTypeInferenceHotPlugin);

    // TODO-TABLES: Remove once DraftJS is fully deprecated
    registerPlugin(DraftJSFormulaCellReferenceHotPlugin);
    registerPlugin(DraftJSFormulaAutocompleteHotPlugin);

    // Register Handsontable custom editor
    registerEditor('draftCellEditor', DraftCellEditor);
};
